<template lang="pug">
  .row.wrapper-spacing
    .small-12.columns(v-if="items.length")
      h1 Monatliche Indexentwicklung <span v-html="indexName"/> {{ month }}

      .spv-table-wrapper: table.spv-product-table.spv-index-table.spv-index-table--vip-euro
        thead
          tr.tr-thick-border
            th.th-caption.medium-6 Monat
            th.th-caption.medium-3: .spv-info-wrapper.flex-wrapper
              span Index­ent&shy;wick­lung
              .info-overlay
                .info-overlay__icon.header-info: i.fo.icon-info_kreis
                .info-overlay__text.right-auto {{ infoTexts[0] }}

            th.th-caption.medium-3: .spv-info-wrapper.flex-wrapper
              span Mit Cap bei {{ targetVol }}
              .info-overlay
                .info-overlay__icon.header-info: i.fo.icon-info_kreis
                .info-overlay__text(v-html="infoTexts[1]")

        tbody
          tr(v-for="(item, index) in items" :key="index")
            td {{ formatDate(item.date) }}
            td {{ formatPercent(item.index_value_percent, 2) }}
            td {{ formatPercent(item.index_cap, 2) }}

        tfoot
          tr
            td &nbsp;
            td.td-padding: .spv-info-wrapper.overlay-sm-flex Jahres&shy;rendite
              .info-overlay
                .info-overlay__icon: i.fo.icon-info_kreis
                .info-overlay__text.right-auto(v-html="infoTexts[3]")

            td {{ formatPercent(yearlyYield, 2) }}

          tr
            td &nbsp;
            td
              .spv-info-wrapper.hide-all.show-medium.show-large Maßgebliche
                .info-overlay Jahresrendite
                  .info-overlay__icon: i.fo.icon-info_kreis
                  .info-overlay__text.right-auto {{ infoTexts[2] }}

              .spv-info-wrapper.overlay-sm-flex.hide-all.show-small Maßgebliche Jahres&shy;rendite
                .info-overlay
                  .info-overlay__icon: i.fo.icon-info_kreis
                  .info-overlay__text.right-auto {{ infoTexts[2] }}

            td {{ formatPercent(decisiveYield, 2) }}

      .pdf-button-wrapper
        a.button.button-small(@click="$emit('print')") Drucken

    .medium-12.large-12.columns(v-else)
      h1.no-margin Keine Monatswerte für <span v-html="indexName"/> für {{ month }} vorhanden.

</template>

<script>
export default {
  name: 'index-euro-table',

  props: {
    items: {
      type: Array,
      default: () => []
    },

    indexId: {
      type: String,
      default: ''
    },

    indexName: {
      type: String,
      default: ''
    },

    month: {
      type: String,
      default: ''
    },

    targetVol: {
      type: String,
      default: ''
    },

    yearlyYield: {
      type: Number,
      default: 0
    },

    decisiveYield: {
      type: Number,
      default: 0
    },

    infoTexts: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    formatDate (value) {
      if (!value) {
        return '';
      }

      return this.$parent.formatDate(value, 'MM / YYYY');
    },

    formatPercent (v, decimals) {
      return this.$parent.formatPercent(v, decimals);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/index/index-euro-table.vue